const withState = require("../../../../utils/withState");
const {isUserAccessed, account$} = require("../../../../emitters/account");
const {PERMISSION_DASHBOARD, PERMISSION_WITHDRAW, PERMISSION_PAYOUT_HISTORY} = require("../../../../constants/permissions");
const {apiV2AssetsAmountList, apiV2KlubcoinAmountFees, apiV2NCDTAmountFees, apiV2AssetsAmountLimits} = require("../../../../api/merchant/assetsAmount");
const Caption = require("../../../dumb/Caption/C");
const React = require("react");
const Loading = require("../../../dumb/Loading");
const Balance = require("./components/Balance");
const {paramStore} = require("../../../../stores");
const WithdrawTable = require("./components/WithdrawTable");
const KlubcoinFees = require("./components/KlubcoinFees");
const MessageBankAccountNeeded = require("./components/MessageBankAccountNeeded").default;
const Ripple = require("../../../dumb/Ripple");
const {SecondLayerTabs} = require("../../../helpers/Menu");
const {useBlockHeightObserver} = require("../../../../utils/useBlockHeightObserver");
const {Box} = require("@material-ui/core");
const {BtnBlueFilled} = require("../../../helpers/Buttons");
const {pushLocation} = require("../../../../router");
const links = require("../../../../constants/links");
const {MerchantPageHeader} = require("../../../helpers/Display");

const tab$ = paramStore('tab', 'payouts');

const VIEWS = {
  payouts: WithdrawTable,
  klubcoinFees: KlubcoinFees
};

const ContentDisplay = (props) => {
  const currentTab = props.currentTab;
  const assetsLimits = props.assetsLimits || {};
  const assets = props.assets || [];

  const assetCode = props.assetCode || "";

  const {ref, height} = useBlockHeightObserver();

  const payoutsAvailable = isUserAccessed(PERMISSION_PAYOUT_HISTORY);

  if (!payoutsAvailable) {
    tab$.emit('klubcoinFees');
  }

  const links = [
    payoutsAvailable && {
      id: 'payouts',
      name: 'Payouts'
    },
    {
      id: 'klubcoinFees',
      name: 'Fees'
    }
  ].filter((el) => el);

  return (
    <>
      {!assets.length && (
        <MessageBankAccountNeeded />
      )}
      <Box ref={ref} mt="1.4rem" mb="2rem">
        <Balance
          assets={props.assets}
          assetCode={assetCode}
          assetsLimits={assetsLimits}
          handleChangeAssetCode={props.onAssetCodeChange}
          disabledBalance={props.disabledBalance}
        />
      </Box>
      {!!assets.length && (
        <SecondLayerTabs
          links={links}
          activeId={currentTab}
          emitter={tab$.emit}
          viewProps={{assetCode, topBlockHeight: height}}
          views={VIEWS}
        />
      )}
    </>
  )
}

module.exports = withState((setState, self, onMount) => {
  const disabledBalance = !isUserAccessed(PERMISSION_DASHBOARD);
  const account = account$.getValue();
  const defaultCurrency = account.fiat_code;
  const currencyParam$ = paramStore('assetCode', defaultCurrency);

  self.state = {...self.state, loading: true};

  disabledBalance || onMount(async () => {
    const assets = await apiV2AssetsAmountList({limit: 1000})
      .then((res = {}) => {
        const list = res.list || [];
        return list.map((el) => {
          const {fiat_code, sc_code, ...props} = el;
          const isFiat = !!fiat_code;
          const asset_code = isFiat ? fiat_code : sc_code;
          const type = isFiat ? 'fiat' : 'stablecoin';
          return {...props, asset_code, type};
        })
      });

    if (!assets.length) {
      setState({
        loading: false,
        assets,
        assetCode: defaultCurrency,
      });

      return;
    }

    const fiatCodes = assets.filter((el) => el.type === 'fiat').map((el) => el.asset_code);

    const assetsLimits = await apiV2AssetsAmountLimits({
      fiat_codes: fiatCodes,
      min_amount: 500
    });

    const feesFN = account.is_klubcoin
      ? apiV2KlubcoinAmountFees
      : account.is_ncdt
        ? apiV2NCDTAmountFees
        : new Promise((resolve) => resolve({}));

    const fees = await feesFN();
    const currencyInParams = currencyParam$.getValue();
    const paramsCurrencyHasBalance = assets.find((el) => el.asset_code === currencyInParams);

    const assetCode = paramsCurrencyHasBalance
      ? currencyInParams
      : assets[0].asset_code;

    setState({
      loading: false,
      assets,
      assetsLimits,
      fees,
      assetCode,
    });
  })

  return (state) => {

    const assetCode = state.assetCode || "";
    const fees = state.fees || {};
    const feeData = fees[assetCode] || {};

    const headerStatistic = [
      {title: 'Total payments amount', value: feeData.total_amount},
      {title: 'Fee amount', value: feeData.fee_amount}
    ];

    return (
      <>
        <MerchantPageHeader
          title="Dashboard"
          rightBlock={(
            <Box display="flex" justifyItems="center" margin="0 -1rem">
              {headerStatistic.map((el, id) => (
                <Box key={id} display="flex" justifyItems="center" p="0 1rem">
                  <span className="dB fw3 mr6">{`${el.title}:`}</span>
                  <span className="dB fw7">{el.value || '0'} {assetCode}</span>
                </Box>
              ))}
            </Box>
          )}
        />
        {state.loading
          ? <Loading />
          : (
            <ContentDisplay
              currentTab={state.currentTab}
              assetCode={state.assetCode}
              assetsLimits={state.assetsLimits}
              assets={state.assets}
              onAssetCodeChange={(name, assetCode) => {
                setState({assetCode});
                currencyParam$.emit(assetCode);
              }}
              disabledBalance={disabledBalance}
            />
          )
        }
      </>
    )
  }
}, {
  currentTab: tab$,
})
